import { ModelGallery } from '@sloyd/ui';
import { Wrapper } from './Community.style';

export type CommunityProps = {
  browseGallery: any[];
};

export function Community(props: CommunityProps) {
  const { browseGallery } = props;

  return (
    <Wrapper className='Community-wrapper' data-testid='Community-wrapper'>
      <ModelGallery
        baseImageUrl='https://cdn.prod.website-files.com/62b61ea35d1d736623887bf7'
        items={browseGallery}
      />
    </Wrapper>
  );
}

export default Community;
